import { render } from "./PromotionalBanners.vue?vue&type=template&id=0984c684&scoped=true"
import script from "./PromotionalBanners.vue?vue&type=script&lang=js"
export * from "./PromotionalBanners.vue?vue&type=script&lang=js"

import "./PromotionalBanners.vue?vue&type=style&index=0&id=0984c684&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0984c684"]])

export default __exports__